const { createRecipeTiles } = require('../shop/tiles/recipe-tile-factory');

class SearchRecipeTileListController {
    constructor(settings, analyticsService, searchService, sortByKeys) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
    }

    createTiles(tiles) {
        return {
            items: createRecipeTiles(tiles.items),
            totalRecordCount: tiles.totalRecordCount,
        };
    }

    pushToAnalytics(tiles) {
        if (this.searchService.isHeaderSearch) {
            this.searchService.isHeaderSearch = false;
            const searchKeywordType = this.settings.search.suggestionType === 'completion' ? 'SuggestedV3' : 'Suggested';
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    searchKeyword: this.searchTerm,
                    listKeywords: this.multisearchItems,
                    searchResult: tiles,
                    refinementsUsed: 'All Recipes',
                    searchKeywordType: this.searchService.isAutocompleteSearch ? searchKeywordType : 'Self-typed',
                },
                type: this.analyticsService.mapperTypes.customEvent.search.success,
            });

            this.searchService.isAutocompleteSearch = false;
        }

        return tiles;
    }

    getTiles(pageSize, pageNumber, sortType) {
        return this.searchService.doSearchRecipes(this.searchTerm, pageSize, pageNumber, sortType)
            .then(tiles => this.createTiles(tiles))
            .then(tiles => this.pushToAnalytics(tiles));
    }

    createAnalyticsData(contentData) {
        return {
            type: 'recipes',
            sortOptions: this.sortOptions,
            sortBy: contentData.sortType ? contentData.sortType.Value : '',
            searchKeyword: this.searchTerm,
            listKeywords: this.multisearchItems,
            searchResult: contentData,
            pageNumber: this.pageNumber,
        };
    }

    pushContentDataToAnalytics(contentData) {
        this.analyticsService.push({
            data: this.createAnalyticsData(contentData),
            type: this.analyticsService.mapperTypes.search.result,
        });
    }
}

SearchRecipeTileListController.$inject = ['Settings', 'AnalyticsService', 'SearchService', 'SortByKeys'];

const searchRecipeTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: SearchRecipeTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.settings.search.searchHeadingText + ' “' + $ctrl.searchTerm + '”'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)"
            should-remember-sort="::$ctrl.settings.search.shouldRememberSort"
            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)">

            <zero-result>
                <wow-search-zero-results></wow-search-zero-results>
            </zero-result>
        </wow-tile-list>
    `,
};

module.exports = {
    SearchRecipeTileListController,
    searchRecipeTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-recipe-tile-list.component.js